/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import OCRLabSerializer from '../types/OCRLabSerializer_apps_LAB'


const HOST = `${config.API_HOST}`

const setContentType = (base: BaseService, data: any) => {
  if (data instanceof FormData) {
    base.client.defaults.headers.common["Content-Type"] = "multipart/form-data";
  } else if (data instanceof URLSearchParams) {
    base.client.defaults.headers.common["Content-Type"] = "application/x-www-form-urlencoded";
  }
};

/* ['generics.UpdateAPIView'] */
/* params:  */
/* data:  */
const OCRLabDetail : 
{
  update:   ({pk, params, data, apiToken, extra}:
             { pk: any, 
                params?: any,
                data?: Partial<OCRLabSerializer> | FormData,
                apiToken?: any,
                extra?: any,
            }) => any,
  patch:    ({pk, params, data, apiToken, extra}:
             { pk: any, 
                params?: any,
                data?: Partial<OCRLabSerializer> | FormData,
                apiToken?: any,
                extra?: any,
            }) => any,
} = 
{
  update: async ({pk, params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    setContentType(base, data);
    const result = await to(base.client.put(`${HOST}/apis/LAB/ocr-lab/${pk}/`,
      data,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },

  patch: async ({pk, params, data, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    setContentType(base, data);
    const result = await to(base.client.patch(`${HOST}/apis/LAB/ocr-lab/${pk}/`,
      data,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default OCRLabDetail